import styled, { css } from 'styled-components'

export const SIDEBAR_WIDTH = 215

export const Sidebar = styled.div(
  ({ theme }) => css`
    width: ${SIDEBAR_WIDTH}px;
    flex-shrink: 0;
    padding: 16px;
    border-right: 1px solid ${theme.colors.border[1]};
    position: fixed;
    height: calc(100% - 100px);
    overflow-y: auto;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  `
)

export const Content = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
  margin-left: ${SIDEBAR_WIDTH}px;
  margin-bottom: 44px;
  margin-top: 16px;
`
